<template>
  <PubPage showProject @changeProject="changeProject">
    <template slot="pageHeader">
      <div class="project-tabs">
        <a-tabs v-model="tabsDefaultKey" @change="changeType">
          <a-tab-pane
            v-for="item in tabsList"
            :key="item.id"
            :tab="item.name"
          />
        </a-tabs>
      </div>
    </template>
    <BasicTable
      :columns="columns"
      bordered
      :dataSource="list"
      :loading="loading"
      boxShadow
      :pagination="{
        current: form.paging.page,
        pageSize: form.paging.limit,
        total: pageTotal,
      }"
      :row-selection="{
        selectedRowKeys: selectedRowKeys,
        onChange: (aa, bb) => {
          selectedRowKeys = aa;
        },
      }"
      @searchBack="searchBack"
      @pagesChange="pagesChange"
    >
      <template #tableTitle>
        <div class="pub-tableTitle-button">
          <a-button
            type="primary"
            class="btn-blue"
            icon="plus-circle"
            @click="add()"
            >添加学生</a-button
          >
          <a-button icon="delete" @click="deleteCustomer(selectedRowKeys)"
            >批量删除</a-button
          >
          <PubImportFile
            btnText="导入学生"
            businessType="PERSONNEL_CONTRACT"
            @uploadOk="uploadOk"
            :loading="importLoading"
          />
          <a
            href="https://image.91zhkj.com/schoolFaceFile/template/%E5%AE%BF%E8%88%8D%E4%BA%BA%E5%91%98%E4%BF%A1%E6%81%AF%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx"
            download="导入学生模板"
            target="_blank"
            >下载模板</a
          >
        </div>
      </template>
      <template slot="index" slot-scope="{ index }">
        {{ index + 1 }}
      </template>
      <template slot="status" slot-scope="{ record }">
        <PubEnableStatus :status="record.status" />
      </template>

      <template slot="options" slot-scope="{ record }">
        <div class="pub-options">
          <a @click="deleteCustomer([record.id])" class="red">
            <a-icon type="delete" />删除
          </a>
        </div>
      </template>
    </BasicTable>
    <AddModal ref="addModalModal" @ok="moduleOk" />
  </PubPage>
</template>

<script>
import { Dormitory } from "@/api";
import AddModal from "./AddModal.vue";
import PubImportFile from "@/components/PubImportFile";
export default {
  components: {
    AddModal,
    PubImportFile,
  },
  data() {
    const columns = [
      {
        title: "序号",
        dataIndex: "index",
        align: "center",
        width: 50,
        hideInSearch: true,
        scopedSlots: true,
      },
      {
        title: "姓名",
        dataIndex: "personnelName",
      },
      {
        title: "班级",
        dataIndex: "gradeClassName",
        hideInSearch: true,
      },
      {
        title: "班级",
        dataIndex: "gradeClassId",
        align: "center",
        hideInTable: true,
        valueType: "select",
        fieldProps: {
          placeholder: "请选择班级",
          option: () =>
            this.common.getAllClass(this.$store.state.user.schoolId),
        },
      },
      {
        title: "状态",
        dataIndex: "status",
        align: "center",
        scopedSlots: true,
        valueType: "select",
        width: 100,
        fieldProps: {
          placeholder: "请选择状态",
          option: () => this.common.findSysCodeType("SYS_STATUS"),
        },
      },
      {
        title: "操作",
        align: "center",
        width: 130,
        dataIndex: "options",
        hideInSearch: true,
        scopedSlots: true,
      },
    ];
    return {
      form: {
        paging: {
          page: 1,
          limit: 20,
          sort: [
            {
              property: "createTime",
              direction: "DESC",
            },
          ],
        },
      },
      list: [],
      tabsList: [],
      pageTotal: 0,
      loading: false,
      importLoading: false,
      tabsDefaultKey: "",
      columns,
      selectedRowKeys: [],
    };
  },
  created() {},
  mounted() {},
  methods: {
    // 切换学校
    changeProject() {
      this.form.schoolId = this.$store.state.user.schoolId;
      this.form.paging.page = 1;
      this.columns = [...this.columns];
      this.getDormList();
    },
    // 切换
    changeType(type) {
      this.tabsDefaultKey = type;
      this.form.dormitorySetId = type;
      this.getList();
    },
    // 获取数据
    getDormList() {
      this.loading = true;
      Dormitory.schoolDormitoryPage({
        schoolId: this.$store.state.user.schoolId,
        paging: {
          page: 1,
          limit: 20,
        },
      }).then(res => {
        if (res.code == this.config.pubCode) {
          this.tabsList = res.data;
          this.tabsDefaultKey = res.data[0].id;
          this.form.dormitorySetId = res.data[0].id;
          this.getList();
        }
        this.loading = false;
      });
    },
    // 获取数据
    getList() {
      this.loading = true;
      Dormitory.dormitoryStudentManagePage(this.form).then(res => {
        if (res.code == this.config.pubCode) {
          this.list = res.data;
          this.pageTotal = res.total;
        }
        this.loading = false;
      });
    },
    // 翻页回调
    pagesChange(data) {
      this.form.paging.page = data.current;
      this.form.paging.limit = data.pageSize;
      this.getList();
    },
    // 搜索回调
    searchBack(data) {
      data.paging = {
        page: 1,
        limit: this.form.paging.limit,
      };
      this.form = { ...this.form, ...data };
      this.getList();
    },
    // 删除
    deleteCustomer(id) {
      this.pubMsg.confirm("是否确定删除此数据？").then(() => {
        this.loading = true;
        Dormitory.dormitoryStudentManageDelete({ ids: id.join(",") }).then(
          res => {
            if (res.code == this.config.pubCode) {
              this.pubMsg.tipMessage("删除成功！", "success");
              this.getList();
            }
            this.loading = false;
          }
        );
      });
    },
    // 上传结束
    uploadOk(data) {
      this.importLoading = true;
      Dormitory.teacherBasicImportFile({
        schoolId: this.form.schoolId,
        sysFile: data,
      }).then(res => {
        if (res.code == this.config.pubCode) {
          this.pubMsg.tipMessage("导入成功！", "success");
          this.getList();
        }
        this.importLoading = false;
      });
    },

    add() {
      this.$refs.addModalModal.open(this.tabsDefaultKey);
    },
    moduleOk(data) {
      if (data) {
        this.getList();
      }
    },
  },
};
</script>
<style lang="less">
// 页面头
.project-tabs {
  padding: 0 15px;
  .ant-tabs-bar {
    margin-bottom: 0 !important;
  }
}
</style>
